import { render, staticRenderFns } from "./ItemL.vue?vue&type=template&id=c260d654"
import script from "./ItemL.vue?vue&type=script&lang=js"
export * from "./ItemL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports